var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-purchase-hint"},[_c('div',{staticClass:"test-purchase-hint__proposal-name",domProps:{"innerHTML":_vm._s(_vm.proposalName)}}),_c('div',{staticClass:"test-purchase-hint__price"},[_vm._v(_vm._s(_vm.price))]),_c('div',{staticClass:"test-purchase-hint__number"},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }